import { render, staticRenderFns } from "./listaDeMedicos.vue?vue&type=template&id=d31cb21a"
import script from "./listaDeMedicos.vue?vue&type=script&lang=js"
export * from "./listaDeMedicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports